export default __webpack_public_path__ + "pie-chart-light.508e9df0.svg";